const dom = {
  saveFileFromBase64(reportName: string, base64: string) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(0)
      .map((_, i) => byteCharacters.charCodeAt(i));

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");

    a.href = url;

    a.download = `${reportName}.pdf`;

    a.click();
  },
  // Для ручек, которые отдают файл напрямую (Content-Type: application/pdf),
  // а не base64 внутри JSON.
  saveFileFromBlob(reportName: string, blob: Blob) {
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");

    a.href = url;

    a.download = `${reportName}.pdf`;

    a.click();

    URL.revokeObjectURL(url);
  },
  saveTxtFileFromBase64(reportName: string, blob: Blob) {
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");

    a.href = url;

    a.download = `${reportName}.txt`;

    a.click();
  },
  openFileFromBase64(base64: string) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(0)
      .map((_, i) => byteCharacters.charCodeAt(i));

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl);
  },
};

export default dom;
